import { AdminRoutes, OwnerRoutes, WaiterRoutes } from '../config/routes.config'

import { CustomerRoutes } from '../config/routes.config'

import { Navigate } from 'react-router-dom'
import { ManagerRoutes } from '../config/routes.config'
import { UserRoles } from '../types/userRoles'
import { useAtom } from 'jotai'
import { useAuth } from '../hooks/useAuth'
import { userAtom } from '../stores/userAtom'

export const RootRedirect: React.FC = () => {
  const { logout } = useAuth()
  const [user] = useAtom(userAtom)

  if (!user) {
    return <Navigate to={CustomerRoutes.HOME} replace />
  }

  switch (user.role) {
    case UserRoles.MANAGER:
      return <Navigate to={ManagerRoutes.BOOKINGS} replace />
    case UserRoles.WAITER:
      return <Navigate to={WaiterRoutes.BOOKINGS} replace />
    case UserRoles.OWNER:
      return <Navigate to={OwnerRoutes.BOOKINGS} replace />
    case UserRoles.ADMIN:
      return <Navigate to={AdminRoutes.BOOKINGS} replace />
    default:
      logout()
      return <Navigate to="/403" replace />
  }
}
